module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/animations/template/template.component.scss
// module id = ./src/app/animations/template/template.component.scss
// module chunks = main